import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const BG =
  "https://customer-assets.emergentagent.com/job_engineer-journey-2/artifacts/ms923ji0_WhatsApp%20Image%202026-01-15%20at%2015.41.26.jpeg";

export const Signature = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "15%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.1, 1.3]);

  return (
    <section
      id="signature"
      ref={ref}
      data-testid="signature-section"
      className="relative h-[140vh] bg-black overflow-hidden"
    >
      <motion.div
        style={{ y, scale }}
        className="absolute inset-0 will-change-transform"
      >
        <img
          src={BG}
          alt="Pharmaceutical stainless steel processing plant"
          className="w-full h-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/80" />

      <div className="sticky top-0 h-screen flex items-end md:items-center">
        <div className="max-w-7xl mx-auto px-6 md:px-12 w-full grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 pb-24 md:pb-0">
          <div className="md:col-span-7">
            <p className="overline mb-6" data-testid="signature-overline">
              — Signature work / 2024
            </p>
            <h2
              className="font-heading text-white text-4xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-[-0.03em]"
              data-testid="signature-headline"
            >
              A pharmaceutical pipework system,
              <br />
              <span className="italic font-normal text-[#FF5722]">
                delivered with precision.
              </span>
            </h2>
          </div>

          <div className="md:col-span-5 md:ml-auto md:mt-24">
            <div
              className="glass rounded-2xl p-7 md:p-8 max-w-md"
              data-testid="signature-card"
            >
              <div className="flex items-center justify-between text-xs tracking-[0.25em] uppercase text-white/50 font-mono">
                <span>Case 014</span>
                <span>Swindon, UK</span>
              </div>
              <p className="mt-5 text-white/80 font-body text-base leading-relaxed">
                Hygienic stainless steel pipework installation for one of the
                world's leading pharmaceutical manufacturers — delivered to
                exacting standards with full traceability and consistent weld
                quality throughout.
              </p>
              <div className="mt-7 grid grid-cols-3 gap-5">
                {[
                  ["16", "Weeks"],
                  ["2,000+", "Welds"],
                  ["100%", "Delivered"],
                ].map(([k, v]) => (
                  <div key={v}>
                    <div className="font-heading text-white text-2xl">{k}</div>
                    <div className="text-white/50 text-[11px] mt-1 font-body uppercase tracking-widest">
                      {v}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
